import { z } from 'zod'
import { ChannelStatus, Platform } from '../enums'
import { Id, Instant } from './primitives'

export const Channel = z.object({
  id: Id,
  platform: Platform,
  name: z.string(),
  externalPageId: z.string(),
  status: ChannelStatus,
  lastCheckedAt: Instant.nullable(),
  webhookSubscribed: z.boolean().nullable().optional(),
  lastWebhookAt: Instant.nullable().optional(),
})
export type Channel = z.infer<typeof Channel>

export const ChannelHealth = Channel.pick({ id: true, platform: true, name: true, status: true, webhookSubscribed: true })
export type ChannelHealth = z.infer<typeof ChannelHealth>

export const PAGE_CONNECTIONS = ['connected', 'disconnected', 'removed'] as const
export const PageConnection = z.enum(PAGE_CONNECTIONS)
export type PageConnection = z.infer<typeof PageConnection>

export const StartOAuthRequest = z.strictObject({ platform: Platform })
export type StartOAuthRequest = z.infer<typeof StartOAuthRequest>

export const StartOAuthResponse = z.object({ url: z.url(), expiresAt: Instant })
export type StartOAuthResponse = z.infer<typeof StartOAuthResponse>

export const DisconnectChannelResponse = z.object({ id: Id, deleted: z.literal(true) })
export type DisconnectChannelResponse = z.infer<typeof DisconnectChannelResponse>
